<div class="revoke-order">

  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <mat-tab-group mat-stretch-tabs [(selectedIndex)]="activeTab" animationDuration="20ms"
      class="ya-tab-group ya-tab-group--bodyless ya-tab-group--notStretch">
      <mat-tab>
        <ng-template mat-tab-label>
          <span [@shake]="states['tab1']" langkey="phRevokeOrder_Tab1Title"></span>
        </ng-template>
      </mat-tab>
      <mat-tab [disabled]="form.invalid">
        <ng-template mat-tab-label>
          <span (click)="goToConfirmation()" langkey="phRevokeOrder_Tab2Title"></span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ya-subheader>
  <mat-tab-group mat-stretch-tabs [@.disabled]="true" [(selectedIndex)]="activeTab"
    class="ya-tab-group ya-headerless-tab-group">
    <mat-tab>
      <div class="revoke-order-tab revoke-order-tab-entry ya-page-content ya-page-content--padding">
        <span class="revoke-order-subtitle" langkey="phRevokeOrder_Tab1Subtitle"></span>
        <form [formGroup]="form">
          <div class="ya-input-container">
            <input id="revoke-order-name" type="text" class="ya-input-text" a11y_Input
              [formControlName]="RevokeOrderFormControl.Name" [maxlength]="InputValidationMaxLength.name"
              placeholder=" " [attr.aria-required]="true" (focus)="onInputFocus(RevokeOrderFormControl.Name)"
              (blur)="onInputBlur(RevokeOrderFormControl.Name); setWebViewAfterBlur()" />
            <div class="field_label" [class.field_label--floated]="isFloated(RevokeOrderFormControl.Name)"
              [class.field_label--required]="isRequired(RevokeOrderFormControl.Name)">
              <span>{{ getFieldLabel(RevokeOrderFormControl.Name) }}</span>
            </div>
            <ng-container
              *ngIf="form.get(RevokeOrderFormControl.Name).touched && form.get(RevokeOrderFormControl.Name).invalid">
              <span class="error-label" langkey="phRevokeOrder_ErrorRequired" role="alert"></span>
            </ng-container>
          </div>
          <div class="ya-input-container">
            <input id="revoke-order-email" type="email" class="ya-input-text" a11y_Input
              [formControlName]="RevokeOrderFormControl.Email" [maxlength]="InputValidationMaxLength.email"
              placeholder=" " [attr.aria-required]="true" (focus)="onInputFocus(RevokeOrderFormControl.Email)"
              (blur)="onInputBlur(RevokeOrderFormControl.Email); setWebViewAfterBlur()" />
            <div class="field_label" [class.field_label--floated]="isFloated(RevokeOrderFormControl.Email)"
              [class.field_label--required]="isRequired(RevokeOrderFormControl.Email)">
              <span>{{ getFieldLabel(RevokeOrderFormControl.Email) }}</span>
            </div>
            <ng-container
              *ngIf="form.get(RevokeOrderFormControl.Email).touched && form.get(RevokeOrderFormControl.Email).hasError('required')">
              <span class="error-label" langkey="phRevokeOrder_ErrorRequired" role="alert"></span>
            </ng-container>
            <ng-container
              *ngIf="form.get(RevokeOrderFormControl.Email).touched && form.get(RevokeOrderFormControl.Email).hasError('pattern')">
              <span class="error-label" langkey="phRevokeOrder_ErrorEmailFormat" role="alert"></span>
            </ng-container>
          </div>
          <div class="ya-input-container revoke-order-field--with-hint">
            <input id="revoke-order-ordernumber" type="text" class="ya-input-text" a11y_Input
              [formControlName]="RevokeOrderFormControl.OrderNumber" maxlength="100" placeholder=" "
              [attr.aria-required]="true" (focus)="onInputFocus(RevokeOrderFormControl.OrderNumber)"
              (blur)="onInputBlur(RevokeOrderFormControl.OrderNumber); setWebViewAfterBlur()" />
            <div class="field_label" [class.field_label--floated]="isFloated(RevokeOrderFormControl.OrderNumber)"
              [class.field_label--required]="isRequired(RevokeOrderFormControl.OrderNumber)">
              <span>{{ getFieldLabel(RevokeOrderFormControl.OrderNumber) }}</span>
            </div>
            <ng-container
              *ngIf="form.get(RevokeOrderFormControl.OrderNumber).touched && form.get(RevokeOrderFormControl.OrderNumber).invalid">
              <span class="error-label" langkey="phRevokeOrder_ErrorRequired" role="alert"></span>
            </ng-container>
          </div>
          <span class="revoke-order-hint" langkey="phRevokeOrder_OrderNumberHint"></span>
          <div class="ya-input-container">
            <textarea id="revoke-order-articles" class="ya-input-textarea" a11y_Input
              [formControlName]="RevokeOrderFormControl.Articles" maxlength="200" rows="3" placeholder=" "
              (focus)="onInputFocus(RevokeOrderFormControl.Articles)"
              (blur)="onInputBlur(RevokeOrderFormControl.Articles); setWebViewAfterBlur()">
            </textarea>
            <div class="field_label" [class.field_label--floated]="isFloated(RevokeOrderFormControl.Articles)"
              [class.field_label--required]="isRequired(RevokeOrderFormControl.Articles)">
              <span>{{ getFieldLabel(RevokeOrderFormControl.Articles) }}</span>
              <span class="revoke-order-optional" langkey="phRevokeOrder_Optional"></span>
            </div>
          </div>
          <div class="ya-input-container">
            <textarea id="revoke-order-reason" class="ya-input-textarea" a11y_Input
              [formControlName]="RevokeOrderFormControl.Reason" maxlength="200" rows="3" placeholder=" "
              (focus)="onInputFocus(RevokeOrderFormControl.Reason)"
              (blur)="onInputBlur(RevokeOrderFormControl.Reason); setWebViewAfterBlur()">
            </textarea>
            <div class="field_label" [class.field_label--floated]="isFloated(RevokeOrderFormControl.Reason)"
              [class.field_label--required]="isRequired(RevokeOrderFormControl.Reason)">
              <span>{{ getFieldLabel(RevokeOrderFormControl.Reason) }}</span>
              <span class="revoke-order-optional" langkey="phRevokeOrder_Optional"></span>
            </div>
          </div>
          <div class="revoke-order-actions">
            <div class="ya-webshop-button-container continue-button">
              <button mat-flat-button a11y_Button (click)="goToConfirmation()">
                <span langkey="phGlobal_Continue"></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab>
      <div class="revoke-order-tab revoke-order-tab-confirm ya-page-content ya-page-content--padding">
        <h2 class="revoke-order-title" langkey="phRevokeOrder_Tab2Headline"></h2>
        <span class="revoke-order-subtitle" langkey="phRevokeOrder_Tab2Subtitle"></span>

        <div class="revoke-order-summary-card">
          <div class="revoke-order-summary-row">
            <span class="revoke-order-summary-label" langkey="phRevokeOrder_LabelName"></span>
            <span class="revoke-order-summary-value">{{summaryData?.name}}</span>
          </div>
          <div class="revoke-order-summary-row">
            <span class="revoke-order-summary-label" langkey="phRevokeOrder_LabelEmail"></span>
            <span class="revoke-order-summary-value">{{summaryData?.email}}</span>
          </div>
          <div class="revoke-order-summary-row">
            <span class="revoke-order-summary-label" langkey="phRevokeOrder_LabelOrderNumber"></span>
            <span class="revoke-order-summary-value">{{summaryData?.orderNumber}}</span>
          </div>
          <div class="revoke-order-summary-row">
            <span class="revoke-order-summary-label" langkey="phRevokeOrder_LabelArticles"></span>
            <span class="revoke-order-summary-value">{{summaryData?.articles}}</span>
          </div>
          <div class="revoke-order-summary-row">
            <span class="revoke-order-summary-label" langkey="phRevokeOrder_LabelReason"></span>
            <span class="revoke-order-summary-value">{{summaryData?.reason}}</span>
          </div>
        </div>
        <div class="revoke-order-warning-block">
          <div class="inline-icon revoke-order-warning-icon" inlineSVG="shop-icons.svg#ya-warning-alert"></div>
          <span langkey="phRevokeOrder_ConfirmWarning"></span>
        </div>
        <div class="revoke-order-actions">
          <div class="ya-webshop-button-container continue-button">
            <button mat-flat-button a11y_Button [disabled]="isSubmitting" (click)="confirmRevoke()">
              <span langkey="phRevokeOrder_BtnConfirm"></span>
            </button>
          </div>
        </div>
        <span class="revoke-order-post-hint" langkey="phRevokeOrder_PostConfirmHint"></span>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>